"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.sort.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../redux/selectors");
require("../styles/main.css");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _BuildingWrap = require("./ComponentCards/BuildingWrap");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const _ComponentDetailsList = () => {
  const buildings = (0, _reactRedux.useSelector)(_selectors.getBuildings) || [];
  const hasData = (0, _reactRedux.useSelector)(_selectors.getHasData);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const sortedDataByBuildings = (0, _react.useMemo)(() => {
    /** @todo We should refactor this part. We should avoid unary '+’ */
    const getNumber = building => Number.isNaN(+tV(building.thingBuildingHouseNumber)) ? 0 : +tV(building.thingBuildingHouseNumber);
    const getStreet = building => tV((building === null || building === void 0 ? void 0 : building.thingBuildingStreet) || {});

    /** @todo check logic (getNumber(a) - getNumber(b)) */
    return buildings.sort((a, b) => {
      if (getStreet(a) > getStreet(b) && getNumber(a) - getNumber(b)) {
        return 1;
      }
      if (getStreet(a) < getStreet(b) && getNumber(b) - getNumber(a)) {
        return -1;
      }
      return getNumber(a) - getNumber(b);
    });
  }, [buildings, tV]);
  if (!hasData) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        minHeight: 200
      }
    }, /*#__PURE__*/_react.default.createElement("center", null, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)));
  }
  return sortedDataByBuildings.map(building => /*#__PURE__*/_react.default.createElement(_BuildingWrap.BuildingWrap, {
    key: building.id,
    building: building
  }));
};
var _default = _ComponentDetailsList;
exports.default = _default;